<div class="data-allocation-grid">
  <h3 class="data-allocation-grid__title">{{ title }}</h3>
  <app-basic-grid [configuration]="gridConfiguration" [data]="rows" [hideFilterItems]="true" [resizableColumns]="false">
  </app-basic-grid>
</div>
